var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "video-card" }, [
    _c("div", { staticClass: "video-card__image-container" }, [
      _c("img", {
        staticClass: "video-card__image",
        attrs: {
          src: _vm.thumbnail.url,
          alt: "",
          height: _vm.thumbnail.height,
          width: _vm.thumbnail.width,
        },
      }),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "video-card__body" }, [
      _c("h3", { staticClass: "video-card__title" }, [
        _vm._v("\n      " + _vm._s(_vm.video.title) + "\n    "),
      ]),
      _vm._v(" "),
      _c("a", { staticClass: "post-card__read-more" }, [
        _vm._v("Watch Video ➤"),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/components/VideoCard.vue